import { gql } from '@apollo/client';

export const TEMPORAL_THRESHOLD = gql`
  fragment TemporalThreshold on TemporalThresholdGroup {
    id
    name
    displayUnitId
    recurringThresholds {
      name
      displayName
      daysOfWeek
      exceedances {
        timeRanges {
          startTime
          endTime
        }
        thresholds {
          valueInDisplayUnit
          hexColor
        }
      }
    }
    specialThresholds {
      name
      displayName
      startDate
      endDate
      exceedances {
        timeRanges {
          startTime
          endTime
        }
        thresholds {
          valueInDisplayUnit
          hexColor
        }
      }
    }
  }
`;
